export enum Language {
    DEFAULT = 'auto',
    GERMAN = 'de',
    ENGLISH = 'en',
    ITALIAN = 'it',
    FRENCH = 'fr',
}

export class LocaleLanguage {
    private static AllValues: { [id: string]: LocaleLanguage } = {};

    language: string;
    locale: string;

    private constructor(id: Language, displayValue: string) {
        this.language = id;
        this.locale = displayValue;
    }

    static initialize() {
        LocaleLanguage.AllValues[Language.DEFAULT] = new LocaleLanguage(Language.DEFAULT, 'de-CH');
        LocaleLanguage.AllValues[Language.GERMAN] = new LocaleLanguage(Language.GERMAN, 'de-CH');
        LocaleLanguage.AllValues[Language.ENGLISH] = new LocaleLanguage(Language.ENGLISH, 'en-US');
        LocaleLanguage.AllValues[Language.ITALIAN] = new LocaleLanguage(Language.ITALIAN, 'it-IT');
        LocaleLanguage.AllValues[Language.FRENCH] = new LocaleLanguage(Language.FRENCH, 'fr-FR');
    }

    static getLocaleLanguage(id: string): LocaleLanguage {
        if (Object.keys(this.AllValues).length === 0) {
            this.initialize();
        }

        return LocaleLanguage.AllValues[id];
    }
}
